export default "__VITE_ASSET__DS1hhX_y__"